import { Divider, useBreakpoint } from '@servicetitan/anvil2';

import { BREAKPOINTS_SMALLER_LG } from '../../utils/ux';
import { FC } from 'react';

export const SectionsDivider: FC<{ showDivider: boolean }> = ({ showDivider }) => {
    const breakpoint = useBreakpoint();

    if (!showDivider) {
        return null;
    }

    const isLargeScreen = !BREAKPOINTS_SMALLER_LG.includes(breakpoint?.name ?? '');

    return <Divider vertical={isLargeScreen} />;
};
